const GoodLogo = (props) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 34 33"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.4252 5.19092L33.1252 32.6909H13.8252L24.4252 5.19092Z"
      fill="url(#paint0_radial_3635_34111)"
    />
    <path
      d="M9.75879 5.8999L14.2588 5.8999L14.2588 -9.82285e-05L9.75879 -9.82286e-05L9.75879 5.8999Z"
      fill="#19B0E1"
    />
    <path
      d="M16.925 31.8905L24.425 5.59053C24.525 5.19053 24.325 4.79053 23.825 4.79053H8.525C8.125 4.79053 7.625 5.19053 7.525 5.59053L0.025 31.8905C-0.075 32.2905 0.124999 32.6905 0.624999 32.6905H15.925C16.325 32.6905 16.825 32.2905 16.925 31.8905Z"
      fill="#3300FF"
    />
    <path
      d="M5.1248 30.8904H12.4248C12.9248 29.2904 14.6248 27.9904 16.2248 27.9904L21.4248 9.69043C19.8248 9.69043 18.9248 8.39043 19.3248 6.79043V6.69043H11.9248V6.79043C11.4248 8.39043 9.7248 9.69043 8.1248 9.69043H8.02481L2.9248 27.8904H3.02481C4.72481 27.8904 5.6248 29.1904 5.1248 30.8904ZM6.9248 18.5904C7.8248 15.5904 10.9248 13.1904 13.9248 13.1904C16.9248 13.1904 18.6248 15.6904 17.7248 18.6904C16.8248 21.6904 13.7248 24.0904 10.7248 24.0904C7.7248 23.9904 6.0248 21.4904 6.9248 18.5904Z"
      fill="white"
    />
    <path
      d="M22.525 21.8906H26.625C27.125 21.8906 27.525 22.2906 27.525 22.7906V32.6906H21.625V22.7906C21.625 22.2906 22.025 21.8906 22.525 21.8906Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3635_34111"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.394 32.0071) scale(17.0406)"
      >
        <stop offset="0.00082672" stopColor="#3B6AF6" />
        <stop offset="1" stopColor="#19B0E1" />
      </radialGradient>
    </defs>
  </svg>
)

export default GoodLogo
